export default [
  { routeName: "coursesEdit", tabTitle: "Datos de la convocatoria" },
  { routeName: "courses-courseClients", tabTitle: "Alumnos" },
  { routeName: "courses-coursePhases", tabTitle: "Fases de convocatoria" },
  { routeName: "courses-courseReports", tabTitle: "Informes" },
];
